import React, { useRef } from "react";

import BackIconBlack from "../assets/chevron.svg";
import BackIconWhite from "../assets/chevron-white.svg";
import Box from "./Box";
import Button from "./Button";
import SmallCaps from "./SmallCaps";
import { useHovered } from "../core/hooks";
import { useRouter } from "next/router";

function BackButton() {
  const ref = useRef(null);
  const hovered = useHovered(ref);
  const router = useRouter();

  return (
    <Box display="inline-block" ref={ref}>
      <Button
        onClick={() => {
          router.back();
        }}
        bg={hovered ? "white" : "black"}
        px={10}
        height={30}
        display="flex"
        justifyContent="center"
        alignItems="center"
        border="1px solid black"
        color={hovered ? "black" : "white"}
        transition="background-color 200ms, color 200ms"
      >
        <Box display="flex" alignItems="center">
          <Box position="relative" width="7px" height="12px">
            <Box
              position="absolute"
              top={0}
              left={0}
              height="100%"
              width="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <BackIconBlack />
            </Box>
            <Box
              position="absolute"
              top={0}
              left={0}
              height="100%"
              width="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
              transition="opacity 200ms"
              opacity={hovered ? 0 : 1}
            >
              <BackIconWhite />
            </Box>
          </Box>
          <SmallCaps color="inherit" pl="7px">
            Back
          </SmallCaps>
        </Box>
      </Button>
    </Box>
  );
}

export default BackButton;
